import LinkAccount from './LinkAccount'

export default LinkAccount
